module.exports = __webpack_public_path__ + "static/media/tenantInsurance.8751726d.png";